import React from "react";
import styles from "./scss/Layout.module.scss";

const Layout = ({ children }) => {
  return <div className={styles.roott}>{children}</div>;
};

export default Layout;
